import React from "react";
import Select from "react-select";
import PerformerDropdownIndicator from "./PerformerDropdownIndicator";
import { ESTABLISHMENT_TYPE } from "../../../../utils/constants";

const ESTABLISHMENT_TYPE_OPTIONS = Object.values(ESTABLISHMENT_TYPE).map((each) => ({
  value: each,
  label: each,
}));

interface PerformerBaseFiltersProps {
  establishmentType: string;
  company: string;
  associateCompany: string;
  companies: any[];
  associateCompanies: any[];
  onEstablishmentTypeChange: (option: any) => void;
  onCompanyChange: (option: any) => void;
  onAssociateCompanyChange: (option: any) => void;
}

function PerformerBaseFilters({
  establishmentType,
  company,
  associateCompany,
  companies,
  associateCompanies,
  onEstablishmentTypeChange,
  onCompanyChange,
  onAssociateCompanyChange,
}: PerformerBaseFiltersProps) {
  const companyOptions = companies.map((c: any) => ({ value: c.id, label: c.name }));
  const associateCompanyOptions = associateCompanies.map((c: any) => ({ value: c.id, label: c.name }));

  const selectedEstablishmentType = establishmentType
    ? { value: establishmentType, label: establishmentType }
    : null;

  const selectedCompany = company
    ? { value: company, label: (companies.find((c: any) => c.id === company) || {}).name || "" }
    : null;

  const selectedAssociateCompany = associateCompany
    ? { value: associateCompany, label: (associateCompanies.find((c: any) => c.id === associateCompany) || {}).name || "" }
    : null;

  return (
    <>
      <div>
        <label className="filter-label"><small>Establishment Type</small></label>
        <Select
          placeholder="Select Establishment Type"
          options={ESTABLISHMENT_TYPE_OPTIONS}
          value={selectedEstablishmentType}
          onChange={onEstablishmentTypeChange}
          className="select-control"
          components={{ DropdownIndicator: PerformerDropdownIndicator }}
          isSearchable={false}
        />
      </div>

      <div>
        <label className="filter-label"><small>Company</small></label>
        <Select
          placeholder="Select Company"
          options={companyOptions}
          value={selectedCompany}
          onChange={onCompanyChange}
          isDisabled={!establishmentType}
          className="select-control"
          components={{ DropdownIndicator: PerformerDropdownIndicator }}
        />
      </div>

      <div>
        <label className="filter-label"><small>Associate Company</small></label>
        <Select
          placeholder="Select Associate Company"
          options={associateCompanyOptions}
          value={selectedAssociateCompany}
          onChange={onAssociateCompanyChange}
          isDisabled={!company}
          className="select-control"
          components={{ DropdownIndicator: PerformerDropdownIndicator }}
        />
      </div>
    </>
  );
}

export default PerformerBaseFilters;
